export const moduleNamespace = 'mapComponents';
